// src/networkPatch.js
import axios from "axios";

const SAME_ORIGIN_API = `${window.location.origin}/api`;
const ABSOLUTE_APIS = [
  "https://shopaholics.ge/api",
  "https://www.shopaholics.ge/api",
];

function normalizeApiUrl(url) {
  if (typeof url !== "string") return url;
  for (const base of ABSOLUTE_APIS) {
    if (url.startsWith(base)) {
      return url.replace(base, SAME_ORIGIN_API);
    }
  }
  // თუ პირდაპირ "/api" მოგდიოდა, გადაიყვანე აბსოლუტურად same-origin-ზე
  if (url.startsWith("/api")) {
    return `${window.location.origin}${url}`;
  }
  return url;
}

// -------- Axios patch --------
axios.defaults.withCredentials = false; // საჯარო ენდპოინტებზე თავიდან აიცლის Preflight-ს
axios.interceptors.request.use((config) => {
  // გადააწყვე URL same-origin-ზე
  if (config.url) {
    config.url = normalizeApiUrl(config.url);
    // თუ baseURL ცალკე აქვს, გაუქმე, რომ ზედმეტი გაერთიანება არ მოხდეს
    if (config.baseURL) config.baseURL = "";
  }

  // GET-ზე დაამატე cache-buster
  const method = (config.method || "get").toLowerCase();
  if (method === "get") {
    const now = Date.now().toString();
    const params = new URLSearchParams(config.params || {});
    if (!params.has("_")) params.set("_", now);
    config.params = Object.fromEntries(params.entries());
  }
  return config;
});

// -------- (არასავალდებულო) fetch patch --------
// ჩართე, თუ გაქვს fetch-იც გამოყენებული axios-ის პარალელურად
(function patchFetch() {
  if (!("fetch" in window)) return;
  const _fetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    let url = typeof input === "string" ? input : input.url;

    url = normalizeApiUrl(url);

    const finalInit = { ...init };
    // omit credentials საჯაროებისთვის; თუ საჭიროა, კონკრეტულ ქოლაზე გადაიფარე
    if (!finalInit.credentials) finalInit.credentials = "omit";

    // GET-ზე cache-buster
    const method = (finalInit.method || "GET").toUpperCase();
    if (method === "GET") {
      const u = new URL(url, window.location.origin);
      if (!u.searchParams.has("_")) u.searchParams.set("_", Date.now().toString());
      url = u.toString();
    }
    return _fetch(url, finalInit);
  };
})();
